import type { ComponentPropsWithRef, CSSProperties } from 'react';

import { clsx } from '../../lib/clsx.ts';

import { type Theme } from '../../theme/theme';
import styles from './Glyph.module.css';

type ThemeColor = Theme['color'][keyof Theme['color']];
type ThemeIconSize = Theme['icon'][Extract<keyof Theme['icon'], `size_${string}`>];

interface GlyphProps extends Omit<ComponentPropsWithRef<'span'>, 'children' | 'color'> {
  className?: string;
  source: string;
  color?: ThemeColor | CSSProperties['color'];
  size?: ThemeIconSize;
  mirrorRTL?: boolean;
}

/*
 * Best practice: when passing `source` and `color` through higher-level components,
 * name the props `glyphSource` and `glyphColor` for clarity.
 */
export function Glyph(props: GlyphProps) {
  const { className, source, color, size, mirrorRTL, style, ref, ...rest } = props;

  return (
    <span
      {...rest}
      ref={ref}
      className={clsx(styles.root, className)}
      style={{
        ...style,
        '--prop-mask-image': `url("${source}")`,
        '--prop-size': size,
        '--prop-color': color,
      }}
      data-mirror-rtl={mirrorRTL}
    />
  );
}
